import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a445e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "font-bold text-4xl" }
const _hoisted_3 = { class: "py-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "loading",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75469 17.1915C5.27668 17.0676 4.99236 16.5901 5.11964 16.1249C6.90138 9.61316 12.9838 5 20.0075 5C25.877 5 31.1111 8.22361 33.7061 13.1244L34.2649 7.43001L34.2946 7.27377C34.4096 6.87105 34.8017 6.58782 35.2366 6.61943C35.7259 6.65499 36.0841 7.07557 36.0368 7.5588L35.215 15.9414L35.1819 16.1099C35.0368 16.5946 34.4946 16.883 33.9987 16.699L26.0765 13.7592L25.9333 13.6909C25.5757 13.4782 25.4181 13.0341 25.5803 12.6306L25.653 12.4877C25.877 12.1303 26.3314 11.9647 26.7371 12.1153L32.2339 14.1556C29.985 9.69468 25.2869 6.74328 20.0075 6.74328C13.8006 6.74328 8.42477 10.8205 6.85066 16.5735C6.73752 16.987 6.33725 17.2516 5.91397 17.2183L5.75469 17.1915ZM34.2457 22.8085L34.0864 22.7817C33.6631 22.7484 33.2628 23.013 33.1497 23.4265C31.5756 29.1795 26.1998 33.2567 19.9929 33.2567C14.7137 33.2567 10.0158 30.3056 7.76677 25.8451L13.2633 27.885C13.6691 28.0356 14.1234 27.87 14.3475 27.5125L14.4201 27.3697C14.5823 26.9662 14.4248 26.5221 14.0672 26.3094L13.9239 26.241L6.00169 23.3013C5.50582 23.1173 4.96368 23.4057 4.81853 23.8904L4.78546 24.0589L3.96368 32.4415C3.91631 32.9247 4.27455 33.3453 4.76384 33.3809C5.19876 33.4125 5.59083 33.1292 5.70586 32.7265L5.73555 32.5703L6.29363 26.8744C8.88845 31.7759 14.1229 35 19.9929 35C27.0166 35 33.099 30.3868 34.8807 23.8751C35.008 23.4099 34.7237 22.9324 34.2457 22.8085Z",
    fill: "#606B85"
  })
], -1))

import { Stage } from '@/types/enums/video-diagnostic.enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
  stage: {
    type: Number,
    required: true,
  },
  header: {
    type: String,
    default: '',
  },
  message: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _unref(Stage).CONNECTIVITY,
    class: _normalizeClass([
      __props.stage === _unref(Stage).CONNECTIVITY ? 'block' : 'hidden md:block opacity-30 pointer-events-none'
    , "text-center max-w-sm mx-auto py-10"])
  }, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.header), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1),
    _hoisted_4
  ], 10, _hoisted_1))
}
}

})